import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, Ref } from 'vue';
import { throttle } from 'lodash';
import { SeriesObjectType } from '@/components/charts/utils/utils.types';
import { ChartTypes } from '@/components/Common/graph.types';

interface Props {
  chartOptions: object;
  series: SeriesObjectType[];
  type?: ChartTypes;
  height?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'multi-chart-v3',
  props: {
    chartOptions: {},
    series: {},
    type: {},
    height: {}
  },
  emits: ['onMouseMove'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;
const props = __props;
const chart: any = ref(null);
__expose({
  chart,
});

const onMove = throttle(function (_event, _chartContext, config) {
  if (config.dataPointIndex >= 0) {
    const dataPoint = props.series?.map((obj) => {
      return {
        y: obj.data[config.dataPointIndex]?.y,
        x: obj.data[config.dataPointIndex]?.x,
      };
    });
    emit('onMouseMove', dataPoint);
  }
}, 100);

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock(_component_apexchart, {
    ref_key: "chart",
    ref: chart,
    height: "100%",
    width: "100%",
    type: props.type,
    options: props.chartOptions,
    series: props.series,
    onMouseMove: _unref(onMove)
  }, null, 8, ["type", "options", "series", "onMouseMove"]))
}
}

})